import { render, staticRenderFns } from "./AdvancedSelectors.vue?vue&type=template&id=4c823eba&scoped=true&"
import script from "./AdvancedSelectors.vue?vue&type=script&lang=js&"
export * from "./AdvancedSelectors.vue?vue&type=script&lang=js&"
import style0 from "./AdvancedSelectors.vue?vue&type=style&index=0&id=4c823eba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c823eba",
  null
  
)

export default component.exports